var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{staticStyle:{"max-width":"30px","overflow":"scroll"},attrs:{"id":"modal-medicine-report","size":"xl","title":"Expor Daftar Obat dan Alkes","hide-footer":""}},[_c('Table',{attrs:{"dataModal":_vm.dataModal,"excel":_vm.excel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }